import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import Home from "./pages/Home";
import Error from "./pages/Error";
import Header from "./components/Header";
import Footer from "./components/Footer";

import About from "./pages/About";
import Rooms from "./pages/Rooms";
import Services from "./pages/Services";
import Pool from "./pages/Pool";
import Where from "./pages/Where";
import SingleRoom from './pages/SingleRoom';
import Policy from "./pages/Policy";

import ScrollToTop from "./components/ScrollToTop";
import BookingWidget from "./components/BookingWidget";


function App() {

 return (<>
  <Router>
    <ScrollToTop />
    <div style={{position: 'relative'}}>
    <Header />
    <div style={{paddingTop: '75px'}}>
      <Routes>
        <Route path="/" element={<Home />} />

        <Route path="/about" element={<About />} />
        <Route path="/rooms" element={<Rooms />} />
        <Route path="/rooms/:id" element={<SingleRoom />} />
        
        <Route path="/services" element={<Services />} />
        <Route path="/pool" element={<Pool />} />
        <Route path="/where" element={<Where />} />

        <Route path="/policy" element={<Policy />} />

        <Route path="*" element={<Error />} />
      </Routes>
    </div>
    <Footer />
    <BookingWidget />
    </div>
  </Router>
    
 </>

 )
}
export default App;